import "../App.css";
import "../styling/Program.css";

// Common Elements
import ProgramNavBar from "../Components/ProgramNavBar";

// Boostrap Imports
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Tab from "react-bootstrap/Tab";
import Container from "react-bootstrap/Container";

// Graphics
import SecondaryLogo from "../images/secondary_logo.png";
import DecEventPoster from "../images/events/dec25_poster.jpg";

function Home() {
  return (
    <div>
      <div id="program_page" className="program_background">
        <ProgramNavBar />
        <Tab.Container>
          <Row style={{ paddingTop: "5vh" }}>
            <Tab.Content>
              <Container className="tab_header">
                <Row>
                  <Col sm={4}></Col>
                  <Col sm={4}>
                    <img className="tab_image" src={SecondaryLogo} alt=""></img>
                    <div style={{ lineHeight: "1" }}>
                      <h6>
                        <b>May 30, 2026</b>
                      </h6>
                      <h6>
                        <b>Judson Memorial Church - The Gym</b>
                      </h6>
                      <br></br>
                      <div style={{ textAlign: "left" }}>
                        <p>Presented by Friday Walk</p>
                        <p>
                          Produced and Curated by Kayla White & Taylor
                          Schmuelgen
                        </p>
                        <p>Photography by Rosa Allegra Wolff</p>
                        <p>Videography by Makenna Finch</p>
                      </div>
                    </div>
                  </Col>
                  <Col sm={4}></Col>
                </Row>
                <Row>
                  <Col sm={2}></Col>{" "}
                  <Col sm={8}>
                    {" "}
                    {/* <img
                      className="tab_image"
                      src={DecEventPoster}
                      alt=""
                    ></img> */}
                  </Col>{" "}
                  <Col sm={2}></Col>
                </Row>
                <Row style={{ paddingBottom: "10vh", paddingTop: "5vh" }}>
                  <h4 style={{ paddingBottom: "5vh" }}>
                    <b>Run of Show</b>
                  </h4>
                  <div style={{ textAlign: "left" }}>
                    <h5>
                      <b>Late Bloom</b>
                    </h5>
                    <p>Created and Performed by Brooke Lutz</p>
                  </div>
                  <div style={{ textAlign: "left", paddingTop: "2vh" }}>
                    <h5>
                      <b>Rhythm Study</b>
                    </h5>
                    <div style={{ lineHeight: "1" }}>
                      <p>Created by Elizabeth Buchheister</p>
                      <p>
                        Performed by Solenn Etienne, Claudia Logi, Jessie
                        Hernandez, Sarah Hutchinson, Lexi Sim, Guenivere
                        Ontiveros
                      </p>
                      <p>New Music by Ryan Wolfe</p>
                    </div>
                  </div>
                  <br></br>
                  <div style={{ textAlign: "left", paddingTop: "2vh" }}>
                    <h5>
                      <b>Step Right Up!</b>
                    </h5>
                    <div style={{ lineHeight: "1" }}>
                      <p>Created and Performed by Faride Henaine Gutiérrez</p>
                      <p>Music by Tom Waits</p>
                      <p>Music Editing by Lindsey Phillips</p>
                    </div>
                    <p>
                      <i>
                        This piece is inspired by the tradition of classic
                        American sideshow performance and the sense of wonder,
                        risk, and spectacle that comes with it. Through movement
                        and live performance elements, I hope to bring this art
                        form into spaces where audiences may have never
                        experienced anything like it before, creating curiosity,
                        excitement, and a new connection to performance
                        traditions that are often overlooked.
                      </i>
                    </p>
                  </div>
                  <br></br>
                  <h5 style={{ paddingTop: "5vh", paddingBottom: "5vh" }}>
                    <b>
                      <i>Intermission</i>
                    </b>
                  </h5>
                  <div style={{ textAlign: "right" }}>
                    <h5>
                      <b>FUGUE [STATE]</b>
                    </h5>
                    <p>Created by Yael Haskal</p>
                    <p>
                      Performed and Sound Designed by Yael Haskal and Anna Zheng
                    </p>
                    <p>
                      Music Credits: Johannes Bach, Goldie Boutilier, Colleen,
                      Soccer Mommy
                    </p>
                  </div>
                  <div style={{ textAlign: "right", paddingTop: "2vh" }}>
                    <h5>
                      <b>Slumber (excerpt)</b>
                    </h5>
                    <div style={{ lineHeight: "1" }}>
                      <p>
                        Created by Hardy Party in collaboration with dancers
                      </p>
                      <p>Performed by Veronica Allen and Maddie Musgraves</p>
                      <p>
                        Costume design by Church of Martin |{" "}
                        <a href="https://www.churchofmartin.com">
                          churchofmartin.com
                        </a>
                      </p>
                      <p>
                        Music Credits Include “Crickets Chirping” by Trip
                        Shakespeare (layered by Hardy); “All the Way” by Jimmy
                        Scott; “My Purpose” and “To Be Remembered” by LochHaven
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      textAlign: "right",
                      paddingTop: "2vh",
                      paddingBottom: "2vh",
                    }}
                  >
                    <h5>
                      <b>Last 2 Brain Cells</b>
                    </h5>
                    <p>
                      Created and Performed by Anna Hershinow and Julia Asher
                    </p>
                    <p>Costumes by Roque Gil</p>
                  </div>
                  <hr></hr>
                  <h5 style={{ paddingTop: "5vh", paddingBottom: "5vh" }}>
                    <b>
                      <i>About The Artists</i>
                    </b>
                  </h5>
                  <div style={{ textAlign: "left" }}>
                    <p>
                      <i>
                        <b>Veronica Allen</b> (she/her) is a dance artist born
                        and raised in Nebraska. She graduated with a BFA in
                        Dance Performance from the University of California,
                        Irvine, where she was recognized as a Donald McKayle
                        Scholar. During her time there, she worked closely in
                        creation and repertory with Charlotte Griffin, Lar
                        Lubovitch, and Kate Skarpetowska. After moving to New
                        York, she continued her training through GibneyPRO under
                        the direction of Alexandra Wells, performing works by
                        Peter Chu, Ana Maria Lucaciu, Laja Field, Adam Barruch,
                        Lea Ved, and Sidra Bell. Veronica is a Springboard Danse
                        alum and has worked with artists including Bryan Arias,
                        Wesley Ensminger, Akira Uchida, and Waeli Wang. She has
                        also had the privilege of guesting with Adaptations
                        Dance Theater based in Maui, Hawaii. Veronica is
                        currently based in New York City, where she works as a
                        freelance movement artist and collaborator.
                      </i>
                    </p>
                    <p>
                      <i>
                        <b>Elizabeth Buchheister</b> is a choreographer, dancer,
                        producer and teacher based in NYC. Originally from
                        Emmitsburg, Maryland, Elizabeth began performing in
                        community musical theater at a young age. She later
                        studied dance at various schools including The City
                        Ballet School. Elizabeth graduated from The Ailey
                        School’s Certificate program, completed Ailey
                        Extension’s Horton pedagogy certification, and has been
                        a Taylor School scholarship student. Elizabeth has
                        performed works by Alvin Ailey, Paul Taylor, Ronald K
                        Brown, Robert Battle, Amy Hall Garner, and JA
                        Collective. She has choreographed original works for
                        Ballet Hartford, Mercersburg Academy, The City Ballet
                        School, and the new opera "Gracchus." Elizabeth
                        Buchheister and Company have been seen at showcases in
                        NYC, Philadelphia, and Baltimore and sold out shows at
                        Arts on Site. Elizabeth is a 2026 fellow with the
                        Creative Independent Producer Alliance and the founder
                        of “The Study Series,” a monthly showing of
                        choreographic exploration also held at Arts on Site.
                        Elizabeth is a freelance performer, works as an
                        assistant stage manager at Ailey Citigroup Theater,
                        teaches at 92NY Harkness Dance School, and is the
                        Technical Director at Arts on Site.
                      </i>
                    </p>
                    <p>
                      <i>
                        <b>Solenn Etienne</b> was born in Guadeloupe, surrounded
                        by her generous Caribbean culture, inheriting a profound
                        connection to nature and spirituality. Attracted by the
                        vibrating energy of New York City, she joined the Ailey
                        School and graduated in May 2024. Solenn learned
                        repertory from Hofesh Shechter Company, Cleo Parker
                        Robinson Ensemble, and worked with choreographers such
                        as Juliano Nunes, Ronald K. Brown, and Norbert De La
                        Cruz. Solenn is a current member of MODArts Dance
                        Collective, Cie Petra Zanki Company, and aspires to
                        evolve and assert herself in the dance world by freeing
                        her unique expression while transcending her physical
                        limits.
                      </i>
                    </p>
                    <p>
                      <i>
                        <b>Hardy</b> (she/her) is a dance performing artist,
                        singer, and HiveWild company member based in New York,
                        originally from SLC, UT. In 2025, she performed in the
                        Metropolitan Opera’s Salome, set original work Rook with
                        collaborator Steven Bangerter at Brigham Young
                        University, and attended Springboard Danse, where she
                        learned work by Maxine Doyle & Aaron Choate. As a Guest
                        Artist of Gibney Company’s 2024 Summer Tour, Hardy
                        performed Bliss by Johan Inger at Festival des Arts de
                        Saint-Sauveur, Chautauqua Amphitheater, & Jacob’s
                        Pillow. In May 2024, she completed the GibneyPRO
                        Certificate Program under the direction of Alexandra
                        Wells & Bret Yamanaka, working with choreographers Peter
                        Chu, Ana Maria Lucaciu, Laja Field, Adam Barruch, Lea
                        Ved, & Sidra Bell. She received her BFA from BYU and
                        trained across Europe at Orsolina28, ImPulsTanz, Henny
                        Jurriëns, & Deltebre Dansa. Hardy is the founder of
                        SalttoCity and is developing an evening-length
                        production, Slumber, with her company Hardy Party.{" "}
                        <a href="https://www.instagram.com/Hannahbananahardy/">
                          @Hannahbananahardy
                        </a>{" "}
                      </i>
                    </p>
                    <p>
                      <i>
                        <b>Yael Haskal</b> is a writer and performer based in
                        New York/Berlin. She is an ensemble member of the New
                        York Neo-Futurists and La MaMa's Great Jones Repertory
                        Company. She has worked with the Living Theatre,
                        Untitled Theater Company No. 61, and Yoshiko Chuma’s
                        School of Hard Knocks. Grounded in philosophies of
                        exchange and ritual, she creates performance art that
                        animates morbidity with whimsy. Her practice includes
                        poetry, video art, and puppetry. Yael's work has been
                        produced at theatres across the U.S. and abroad,
                        including La MaMa, The Tank, IRT, Echo Theater, and
                        Ivoryton Playhouse. She performs internationally with
                        Great Jones Rep and the New York Neo-Futurists, and was
                        nominated for a 2023 Broadway World Award. She is a
                        graduate of Vassar College (B.A., Drama/English) and
                        arthaus.berlin (M.A., Devised Theatre).
                      </i>
                    </p>
                    <p>
                      <i>
                        <b>Jessie Hernandez,</b>, originally from Huntington
                        Beach, California, is a freelance dance artist,
                        educator, and Pilates instructor based in New York City.
                        As a trained ballet, jazz, tap, modern, and choreography
                        dancer she has performed works for Akomi Dance Company,
                        Bernard Brown (BB Moves), Janessa Clark, Entity
                        Contemporary Dance Company, Joan Rodriguez, Damon Rago,
                        Karissa Royster, Laura Ann Smyth, Pat Taylor (Jazz
                        Antiqua), Taryn Vander Hoop (Summation Dance LA), and
                        Omega Dance Company. Jessie graduated Summa Cum Laude
                        from Loyola Marymount University with a B.A. in Dance
                        alongside minors in Philosophy and Education. She served
                        as president of her university’s NDEO and Movement
                        Exchange chapters, was awarded DEL Arnhold Summer
                        Fellowship, and interned with the LA County Arts
                        Commission. Deeply committed to accessible dance, Jessie
                        is a dance educator and performer for community outreach
                        programs, care facilities, service organizations, and
                        public school residencies on both the east and west
                        coast.
                      </i>
                    </p>
                    <p>
                      <i>
                        <b>Anna Hershinow and Julia Asher</b> are a
                        Brooklyn-based, emerging choreographic duo working at
                        the intersection of dance and performance art. With
                        shared experiences as freelance performers, their
                        collaboration was sparked by a newly inspired
                        reclamation for creative autonomy. With backgrounds in a
                        variety of artistic disciplines, including visual art
                        and filmmaking, their work often experiments with
                        mediums that distort our understanding of the human
                        body. To them, the body is not just a vessel for
                        movement, but a site of imagination–holding
                        multiplicities, refusing definition, forever slipping
                        between unpredictable forms. Julia and Anna are
                        interested in favoring sensation over narrative
                        resolution, leaving behind experiences that live in the
                        body–visceral encounters that unsettle, provoke, and
                        spark recognition.
                      </i>
                    </p>
                    <p>
                      <i>
                        Their latest duet, Last 2 Brain Cells, premiered at the
                        Re/Venue Festival at Mark Morris Dance Center in late
                        2025. They are currently continuing the choreographic
                        development of this work while actively self-producing
                        and pursuing residencies and performance opportunities.
                      </i>
                    </p>
                    <p>
                      <i>
                        <b>Faride Henaine Gutiérrez</b> is a dynamic Mexican
                        modern-based dancer, multidisciplinary artist, and
                        cultural creator with roots in dance and sideshow
                        circus. Influenced by Modern, Burlesque Contemporary,
                        House, Voguing, and Sideshow, her work reflects the bold
                        energy of New York City’s underground scene. She has
                        performed nationally and internationally in Mexico,
                        Sweden, Taiwan, New Orleans and New York including
                        venues like The Joyce Theatre and Coney Island USA.
                        Faride’s innovative fusion of sideshow and dance, along
                        with her collaborations across artistic mediums, marks
                        her as a proud emerging Latinx artist reshaping the
                        future of performance.
                      </i>
                    </p>
                    <p>
                      <i>
                        Born and raised in Washington State,{" "}
                        <b>Sarah Hutchinson’</b>s passion for movement began in
                        ballet and contemporary training that spanned over
                        twelve years. She continued her artistic development at
                        Utah Valley University, earning a BFA in Dance with a
                        focus in Modern/Contemporary. During her time there, she
                        danced with Contemporary Dance Ensemble and Synergy
                        Dance Company and was invited to create work for Synergy
                        and the Movers + Makers workshop. Currently, Sarah is a
                        New York City-based freelance artist performing with
                        various companies such as Salvatore LaRussa Dance
                        Theatre, Threads of Truth, and Buglisi Dance Theatre as
                        well as choreographing and teaching.
                      </i>
                    </p>
                    <p>
                      <i>
                        <b>Claudia Logi</b> is a dancer, based in New York City.
                        She graduated from The Ailey School with a Certificate
                        in Dance. Claudia is now a soloist with American Liberty
                        Ballet and a Company Member with Chutzpah Dance and
                        Reaction Dance Company. Additionally, she is a
                        choreographer as well and focuses on creating
                        collaborative works with artists from various
                        disciplines and is dedicated to showcasing her pieces in
                        unconventional spaces and venues.
                      </i>
                    </p>
                    <p>
                      <i>
                        <b>Brooke Lutz</b> is a performer and creative
                        collaborator based in NYC. Her work spans New York and
                        Los Angeles, including concert dance, dance theater, and
                        screen-based projects.
                      </i>
                    </p>
                    <p>
                      <i>
                        <b>Maddie Musgraves</b> (she/her) is a Brooklyn-based
                        dancer, choreographer, and movement instructor
                        originally from Grand Rapids, Michigan. In May of 2023,
                        she earned her BFA in Dance and a minor in Spanish from
                        Indiana University. While her movement background is
                        rooted in contemporary dance, she has most recently
                        immersed herself in the commercial dance industry and is
                        a crew member of XPro through Brickhouse NYC, directed
                        by Kelly Peters. She has performed works, for both film
                        and live audiences, by artists such as Rob Bynes,
                        Brayden Singley, Kelly Peters, Jojo Brooks, Marcus Allen
                        Cobb, Carlie Anderson, and Audrey Allen. Along with
                        XPro, she has received professional training through the
                        Gibney Company Intensive, the NVA & Guests Workshop, and
                        Dance Italia’s Advanced Training Program. Maddie strives
                        to utilize her diverse training and versatile movement
                        experiences to influence her artistry, expression, and
                        physical storytelling.
                      </i>
                    </p>
                    <p>
                      <i>
                        <b>Guinevere Ontiveros</b> is a mover and creator
                        originally from Fresno, California. She has completed
                        training with Alonzo King LINES Ballet, The Martha
                        Graham School, and The Ailey School. She is forever
                        grateful to have shown and performed works by
                        choreographers including Alvin Ailey, Martha Graham,
                        Alonzo King, Maria Bauman, Darshan Bueller, Jacqulyn
                        Buglisi, Kayla Farrish, Andrea Miller, Freddie Moore,
                        Earl Mosley, Brice Mousset, Marla Phelan, Hofesh
                        Schector, Mike Tyus, and Keelan Whitmore. Her
                        choreographic works have been shown at Dixon Place.
                        Guinevere has been dancing with Elizabeth since 2023.
                      </i>
                    </p>
                    <p>
                      <i>
                        <b>Lexi Sim</b> is a Canadian dancer and choreographer
                        based in New York. Born in Calgary, Canada, she is a
                        graduate of The Ailey School Certificate Program. Her
                        training also includes work with Alberta Ballet,
                        National Ballet of Canada, Joffrey Ballet, Hubbard
                        Street, and Springboard X. Lexi’s performance career
                        spans a wide range of productions, companies, and
                        artistic collaborations across New York. She has
                        performed in Off-Broadway works and with organizations
                        including New York Theater Company, Dance Visions NY,
                        Ballet des Amériques, and The Ride NYC. Her
                        collaborations include work with acclaimed visual artist
                        Jacolby Satterwhite, in An Eclectic Dance to the Music
                        in Time at David Geffen Hall at Lincoln Center.
                        Additional performance credits include We Are All Going
                        to Be Fine (PA, Abrons Arts Center & Dixon Place), The
                        Magical Journey (Theater Row), and Carnival
                        Choreographer’s Ball (LPR), among many others. IG:{" "}
                        <a href="https://www.instagram.com/lexi_sim/">
                          @lexi_sim
                        </a>{" "}
                      </i>
                    </p>
                    <p>
                      <i>
                        <b>Anna Zheng</b> (any) is a director, deviser, and
                        writer interested in acts of adaptation—of stories, of
                        bodies, to other people, to inhospitable
                        environments—and the ways we change ourselves and our
                        narratives to survive in new spaces. They use playful
                        interdisciplinary collaboration, adapted texts, and
                        physical theatre to create unexpected, visceral, joyful
                        messes. Recent directing projects: Run all the way
                        home (ODC Pilot 2025, San Francisco); Constellations by
                        Nick Payne (Stanford IDA); Three States of Matter, a
                        devised climate migration adaptation of Three
                        Sisters; Man of God by Anna Moench (Asian American
                        Theater Project). Anna is a New York Neo Futurist.
                      </i>
                    </p>
                  </div>
                  <h5 style={{ paddingTop: "5vh", paddingBottom: "5vh" }}>
                    <b>
                      <i>Creative Team</i>
                    </b>
                  </h5>
                  <div style={{ textAlign: "left" }}>
                    <p>
                      <i>
                        <b>Kayla White & Taylor Schmuelgen – </b> Taylor
                        Schmuelgen is a Brooklyn based cultural worker,
                        producer, and lover of performance. She is invested in
                        supporting the creation of experimental art through both
                        her role in development at The Kitchen and her own
                        artistic projects. She believes deeply in the power of
                        collaboration, creativity and a good cup of coffee to
                        spark conversation and build community and seeks to be a
                        change maker in the field of experimental performance.
                        Kayla White is a Brooklyn based movement artist,
                        producer, and Pilates instructor. She is an advocate for
                        opportunity: for both deep trust in ourselves and our
                        community. Her artistic practices and teaching practice
                        both heavily rely upon rigor and effort in conversation
                        with relentless softening of self to listen more to our
                        bodies and our surroundings. Together they curate and
                        produce THAT SHOW, a community gathering and showcase of
                        early career performance artists. Informed by a shared
                        vision of a performance space that provides financial
                        and operational support for risk taking and
                        collaboration, their curatorial style has been described
                        as “rooted in TLC: tender loving care” and one that
                        “makes room for unbridled expression.” Taking place at
                        Judson Memorial Church, we embrace a messy,
                        do-it-yourself, community centered model to present and
                        present multiple works in one evening, followed by a DJ
                        set and after-party.
                      </i>
                    </p>
                    <p>
                      <i>
                        <b>Makenna Finch</b> has always seen life through the
                        lens of the moving body. They work to reveal the magic
                        of the periphery by pointing their camera towards people
                        and places that hold unexpected and surreal
                        performances. Makenna graduated from Hampshire College
                        with a major in underwater dance film and installation
                        in 2019 and went on to create personal screendance works
                        as well as document live performances in New York City.
                        She has worked with director and choreographer Celia
                        Rowlson-Hall and for multiple dance production companies
                        filming at Lincoln Center, The Joyce Theatre, New York
                        Live Arts, Harlem Stage, Judson Memorial Church,
                        Dancspace, and many other venues across the five
                        boroughs. Makenna’s last screendance work, Stroke Play,
                        uses golf as a lens to critique and queer social and
                        ecological erosion. She recently started filming 16mm
                        analogue dance films and is collaborating with several
                        dance artists on themes varying from labor across the
                        flower and sex work industry, queer ritual/ nightlife,
                        glitch feminism, and the ever evolving relationship
                        between body and lens.
                      </i>
                    </p>
                    <p>
                      <i>
                        <b>Rosa Allegra Wolff</b> is a world builder — using
                        photography, dance, and choreography to capture the
                        tender human experience. They are a member of the Bill
                        T. Jones/Arnie Zane Company and a 2024 New Choreographer
                        Grant recipient through the Eryc Taylor Dance Company.
                        They have had the privilege to photograph workshops with
                        David Dorfman, Jenn Nugent, Kendra Portier, Jasmine
                        Hearn, and others. Rosa has worked closely with Angelina
                        Laguna and Maqks Gross to photograph their performances.
                        They graduated from George Mason School of Dance in
                        2023, receiving honors in writing and choreography
                        excellence. Rosa’s professional dance and choreography
                        experience is intertwined with their approach to every
                        image. Every person and story has a shape and this is
                        what fuels Rosa’s portrait and performance photography.
                      </i>
                    </p>
                  </div>
                  <h5 style={{ paddingTop: "5vh", paddingBottom: "5vh" }}>
                    <b>
                      <i>About Judson Memorial Church</i>
                    </b>
                  </h5>
                  <div style={{ textAlign: "left" }}>
                    <p>
                      <b>Judson Memorial Church</b> seeks to be a just, diverse,
                      vibrant, and worshipping spiritual community through the
                      pursuit of social justice, creative expression, and sacred
                      exploration of its own Protestant church roots and the
                      wisdom of other traditions.
                    </p>
                    <p>
                      <b>A Place for Spiritual Curiosity:</b> Judson approaches
                      faith not as a monolithic or unchanging set of beliefs but
                      rather as a continual process of action, revelation and
                      exploration. Asking difficult and inconvenient questions
                      of our beliefs and spiritual traditions, and the person of
                      Jesus, is in and of itself a core tenet of faith at
                      Judson.
                    </p>
                    <p>
                      <b>Sacred and Profane:</b> At Judson, it is often said
                      that we hold artists as our modern-day prophets, who not
                      only show us who we are, but what we might become. We find
                      sacred meaning in all parts of life, from the divine to
                      the secular, from ancient scripture to musical theatre.
                    </p>
                    <p>
                      <b>Body and Soul:</b> We concern ourselves with more than
                      the soul; the body is of equal concern. Whether it is
                      bodily autonomy, racial liberation, freedom of sexual or
                      gender expression, or accessibility-- the physical
                      presence of every person in and beyond our community and
                      their ability to enter, move through, and occupy the
                      spaces we create are of paramount importance.
                    </p>
                    <p>
                      <b>Outward and Upward:</b> Since its founding, Judson has
                      maintained deep connections with the civic, political, and
                      social movements outside its walls. Engaging with the
                      world outside of church is not only critical to staying
                      relevant, but it is also how we practice our faith. As
                      Rabbi Abraham Joshua Heschel said, we pray with our feet.
                      In the world, the service begins.
                    </p>
                    <p>
                      <b>VISIT THEIR DONATIONS PAGE AT</b>
                    </p>
                    <p>
                      <b>
                        <a href="https://www.judson.org/give">
                          www.judson.org/give
                        </a>
                      </b>
                    </p>
                  </div>
                </Row>
              </Container>
            </Tab.Content>
          </Row>
        </Tab.Container>
      </div>
    </div>
  );
}

export default Home;
